import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CertSubmissionDuskIds } from '../../../../constants/duskIds';

const ConfirmationPage = ({ props }) => {
  const { url } = useRouteMatch();
  const history = useHistory();

  return (
    <Flex alignItems="center" direction="column" justifyContent="center" minH="50vh">
      <Text mb={8} textStyle="bodyXxl500">Success!  We are currently processing your submission.</Text>
      <Text mb={8}>It may take a minute to see your policies and documents.  You will be receiving an email shortly with your confirmation.</Text>
      <Button
        dusk={CertSubmissionDuskIds.submissionSuccessButton}
        w="350px"
        onClick={() => history.push(url.replace('confirmation', 'submission'))}
      >
        See your submission
      </Button>
    </Flex>
  );
};

ConfirmationPage.propTypes = {};

export default ConfirmationPage;
